/**
 * Return java back API urls
 *
 * ATTENTION:
 * Due to NextJS internals, the process.env.NEXT_PUBLIC_xxx variables are not yet initialized if
 * used in this file global scope. This is why the backUrls variable is not initialized during
 * its declaration. This table init is delayed at the first getApiUrl call.
 */

let backUrls;

export const API_URL = {
  PRODUCT: 0,
  ADMIN: 1,
  USER: 2
};

export const getApiUrl = (index, subRoute) => {
  const isSSR = typeof window === 'undefined';

  if (!backUrls || !backUrls[index].server || !backUrls[index].normal) {
    // Initialize API urls table with variables contained by the .env file
    backUrls = [{
      normal: process.env.NEXT_PUBLIC_API_URL_PRODUCT,
      server: process.env.NEXT_PUBLIC_API_URL_PRODUCT_SSR
    }, {
      normal: process.env.NEXT_PUBLIC_API_URL_ADMIN,
      server: process.env.NEXT_PUBLIC_API_URL_ADMIN_SSR
    }, {
      normal: process.env.NEXT_PUBLIC_API_URL_USER,
      server: process.env.NEXT_PUBLIC_API_URL_USER_SSR
    }];
  }
  // When SSR mode is detected, try to take SSR dedicated url first, else take the 'normal' one
  const key = (isSSR && backUrls[index].server) || backUrls[index].normal;

  return `${key}${subRoute || ''}`;
};
